import React from 'react'
import ReactSelect from 'react-select';
import { useAllFilterBaseContext } from '../../../../../Context/AllFilterBaseContext';

export default function SortOptionType({ filter }) {
    const {
        state,
        setSortByOptions,
    } = useAllFilterBaseContext();

    const {
        sortByOptions,
    } = state;
    return (
        <div>
            <h6>{filter?.title}</h6>
            <ReactSelect
                options={filter.values.map((value) => ({
                    value: value.id,
                    label: value.title,
                }))}
                onChange={(selectedOption) => {
                    setSortByOptions(
                        [selectedOption]?.map((value) => ({
                            id: value.value,
                            title: value.label,
                        })),
                    );
                }}
                value={
                    Array.isArray(sortByOptions)
                        ? sortByOptions?.map((sort) =>
                            filter.values.find((value) => value.id == sort.id)
                                ? {
                                    value: sort.id,
                                    label: filter.values.find(
                                        (value) => value.id == sort.id,
                                    )?.title,
                                }
                                : null,
                        )
                        : null
                }
                placeholder="Select option"
            />
        </div>
    )
}
